import React from 'react';
import PropTypes from 'prop-types';


import { formattedNumber } from '../../../../../../utils/formatterHelpers';
import '../../../../../../grid.css';
import './equivalencies.css';


const Equivalencies = (props) => {
    const {
        annualResults,
    } = props;

    const gas = annualResults[30].systemProduction * 0.08; // gallons of gasoline consumed
    const coal = annualResults[30].systemProduction * 0.773; // Pounds of coal burned
    const homes = annualResults[30].systemProduction * 0.0001; // homes' energy use for one year
    const phones = annualResults[30].systemProduction * 90.2; // number of smartphones charged
    const propane = annualResults[30].systemProduction * 0.029; // propane cylinders
    const oil = annualResults[30].systemProduction * 0.0016 * 168; // propane cylinders
    const miles = annualResults[30].systemProduction * 1.729; // propane cylinders


    const equivalents = [
        { title: 'Smartphones Charged', number: `${formattedNumber(phones)}` },
        { title: 'Gallons of Gasoline', number: `${formattedNumber(gas)}` },
        { title: 'Pounds of Coal Burned', number: `${formattedNumber(coal)}` },
        { title: 'Homes\' Annual Average Consumption', number: `${formattedNumber(homes)}` },
        { title: 'BBQ Propane Cylynders', number: `${formattedNumber(propane)}` },
        { title: 'Pounds of Carbon Sequestered by Acres of U.S. Forests in 1 Year', number: `${formattedNumber(propane)}` },
        { title: 'Quarts of Oil Consumed', number: `${formattedNumber(oil)}` },
        { title: 'Miles Driven by an Average Passenger Vehicle', number: `${formattedNumber(miles)}` },
    ];

    const cards = equivalents.map(term => (
        <div className="col span-2-of-9">
            <p className="number">{term.number}</p>
            <p className="descripton">{term.title}</p>
        </div>
    ));
    return (
        <div className="row">
            <h1 className="title">
                Your system will produce &nbsp;
                {formattedNumber(annualResults[30].cumulativeSystemProduction)} kWh from the Sun.
            </h1>
            <h1 className="subTitle">
              Here are some equivalent figures to put that into perspective.
            </h1>
            <div className="row figures">
                {cards}
            </div>
        </div>
    );
};

Equivalencies.propTypes = {
    annualResults: PropTypes.object.isRequired,
};


export default (Equivalencies);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/Equivalencies/Equivalencies.js